export function isWholeNumber(n: number): boolean {
  return n % 1 === 0;
}

export function isNumber(n: unknown): n is number {
  return typeof n === 'number';
}
